import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import styled from 'styled-components'

import Box from '@material-ui/core/Box'
import Collapse from '@material-ui/core/Collapse'
import IconButton from '@material-ui/core/IconButton'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import Grid from '@material-ui/core/Grid'
import StorageIcon from '@material-ui/icons/Storage'
import TableDetail from './TableDetail'

import { findRoundedOnAllOutput } from '../../../../Assets/mappingData'

const useRowStyles = makeStyles({
    root: {
        '& > *': {
            borderBottom: 'unset',
            lineHeight: 1,
        },
    },
})

const SyledChip = styled.div`
    background: ${({ value }) => (value ? ' #71ab71' : '#f16969')};
    color: white;
    padding: 2px 8px;
    margin: 1px;
    font-size: 13px;
    border-radius: 2px;
    min-width: 32px;
    display: inline-block;
    text-align: center;
`

const ContainerPreviewData = styled.div`
    font-size: 12px;
    padding: 2px 0;
`

const PreviewData = ({ data, name }) => {
    const res = data.find(({ name: calculedName }) => name === calculedName)
    return (
        <>
            {res && (
                <ContainerPreviewData>
                    <div className='preview-data'>
                        {res.name}: <b>{parseFloat(res.value).toFixed(findRoundedOnAllOutput(res.name))}</b>
                    </div>
                </ContainerPreviewData>
            )}
        </>
    )
}

const StyledPreviewData = styled(PreviewData)`
    font-size: 13px;
    margin: 5px;
`

const Row = (props) => {
    const {
        row: { Parameters },
    } = props

    const [open, setOpen] = useState(false)
    const classes = useRowStyles()

    const size = Parameters.map((el) => {
        if (el.Description === 'Size') return el.Values[0].Value
    }).filter(Boolean)
    const optionsValid = Parameters.map((el) => {
        if (el.Values[0].Value === 'TRUE')
            return (
                <SyledChip key={'option-valid-' + el.Description} value={true}>
                    {el.Description}
                </SyledChip>
            )
    }).filter(Boolean)

    const extractCalculationData = (type) =>
        Parameters.map((el) => {
            if (el.Type === 'out' && el.Values[0].Status[0].CalcType?.includes(type))
                return {
                    name: el.Name,
                    value: el.Values[0].Value,
                    type,
                    date: el.Values[0].Status[0]?.Date,
                    time: el.Values[0].Status[0]?.Time,
                    unit: el.Unit,
                }
        }).filter(Boolean)

    const seerLT = extractCalculationData('seerLT')
    const seerMT = extractCalculationData('seerMT')
    const seprHT = extractCalculationData('seprHT')
    const seprMT = extractCalculationData('seprMT')
    const scopLTa = extractCalculationData('scopLTa')
    const scopMTa = extractCalculationData('scopMTa')

    const haveOUtput =
        seerLT.length + seerMT.length + seprHT.length + seprMT.length + scopLTa.length + scopMTa.length !== 0

    return (
        <>
            <TableRow className={classes.root}>
                <TableCell component='th' scope='row'>
                    {optionsValid}
                </TableCell>
                <TableCell align='center' component='th' scope='row'>
                    {size[0]}
                </TableCell>
                <TableCell component='th' align='center' scope='row'>
                    <StyledPreviewData data={seerLT} name='Pdesignc' />
                    <StyledPreviewData data={seerLT} name='SEER' />
                </TableCell>
                <TableCell component='th' align='center' scope='row'>
                    <StyledPreviewData data={seerMT} name='Pdesignc' />
                    <StyledPreviewData data={seerMT} name='SEER' />
                </TableCell>
                <TableCell component='th' align='center' scope='row'>
                    <StyledPreviewData data={seprHT} name='Pdc_A' />
                    <StyledPreviewData data={seprHT} name='SEPR' />
                </TableCell>
                <TableCell component='th' align='center' scope='row'>
                    <StyledPreviewData data={seprMT} name='Pdc_A' />
                    <StyledPreviewData data={seprMT} name='SEPR' />
                </TableCell>
                <TableCell component='th' align='center' scope='row'>
                    <StyledPreviewData data={scopLTa} name='Pdesignh' />
                    <StyledPreviewData data={scopLTa} name='SCOP' />
                </TableCell>
                <TableCell component='th' align='center' scope='row'>
                    <StyledPreviewData data={scopMTa} name='Pdesignh' />
                    <StyledPreviewData data={scopMTa} name='SCOP' />
                </TableCell>
                <TableCell component='th' align='center' scope='row'>
                    <IconButton
                        aria-label='expand row'
                        size='small'
                        disabled={!haveOUtput}
                        onClick={() => setOpen(!open)}>
                        <StorageIcon />
                    </IconButton>
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell
                    style={{
                        paddingBottom: 0,
                        paddingTop: 0,
                    }}
                    colSpan={20}>
                    <Collapse in={open} timeout='auto' unmountOnExit>
                        {open && (
                            <Box margin={1}>
                                <Grid container justify='left' spacing={1}>
                                    {seerLT.length > 0 && <TableDetail calc={seerLT} name='SEER LT' />}
                                    {seerMT.length > 0 && <TableDetail calc={seerMT} name='SEER MT' />}
                                    {seprHT.length > 0 && <TableDetail calc={seprHT} name='SEPR HT' />}
                                    {seprMT.length > 0 && <TableDetail calc={seprMT} name='SEPR MT' />}
                                    {scopLTa.length > 0 && <TableDetail calc={scopLTa} name='SCOP LTa' />}
                                    {scopMTa.length > 0 && <TableDetail calc={scopMTa} name='SCOP MTa' />}
                                </Grid>
                            </Box>
                        )}
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    )
}

export default React.memo(Row)
